/* eslint-disable */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { max } from 'd3-array'
import { geoPath } from 'd3-geo'
import { contourDensity } from 'd3-contour'
import { polygonContains } from 'd3-polygon'
import last from 'lodash/last'
import { RemoveBadSprayPoints } from '../../Utilities/RemoveBadPoints'
import CalculateHitLocation from '../../Utilities/CalculateHitLocation'
import ContourLegend from '../../Legend/ContourLegend'

export default function Contour({ settings, chartOptions = {} }) {
    let sprayData = settings.data

    // Set data to property in data set
    if (chartOptions.linkedDataProperty) {
        sprayData = settings.data[String(chartOptions.linkedDataProperty)]
    }

    if (sprayData.length > 0) {
        const density = contourDensity()
            .x(
                (d) =>
                    CalculateHitLocation(
                        { x: d.x, y: d.y },
                        settings.vizWidth,
                        settings.vizHeight
                    ).x
            )
            .y(
                (d) =>
                    CalculateHitLocation(
                        { x: d.x, y: d.y },
                        settings.vizWidth,
                        settings.vizHeight
                    ).y
            )
            .thresholds(12)
            .size([settings.vizWidth, settings.vizHeight])
            .bandwidth(chartOptions.bandwidth || 12)(sprayData)

        // Use this to calculate legend max density
        density.forEach((d) => {
            d.count = 0
            d.coordinates.forEach((poly) => {
                sprayData.forEach((p) => {
                    const { x, y } = CalculateHitLocation(
                        { x: p.x, y: p.y },
                        settings.vizWidth,
                        settings.vizHeight
                    )
                    if (polygonContains(poly[0], [x, y])) {
                        d.count++
                    }
                })
            })
        })

        const maxCount = last(density).count

        const maxValue = max(density, (d) => d.value)

        const colorDensity = scaleLinear()
            .range(['#3661AD', '#ffffff', '#D82129'])
            .domain([0, maxValue / 2, maxValue])

        const path = geoPath()

        return (
            <>
                <g key="contourChart" id="contourChart">
                    {density.map((d, i) => {
                        const stroke = 'none'
                        if (i <= 5) {
                        }

                        return (
                            <path
                                key={`contour_${i}`}
                                stroke={stroke}
                                d={path(d)}
                                fill={colorDensity(d.value)}
                                opacity={chartOptions.opacity}
                            />
                        )
                    })}
                </g>
                {chartOptions.legend ? (
                    <ContourLegend
                        settings={settings}
                        maxCount={maxCount}
                        opacity={chartOptions.opacity}
                    />
                ) : null}
            </>
        )
    }
    return null
}
